
const preventClosingModal = (element) => {
  return $(element).closest(".modal").length > 0 || $(element).closest(".share-button__email").length > 0;
};

import $ from 'jquery';

/**
 * Created by danielikin on 6.3.2019.
 */

$(document).on('turbo:load', () => {
  $("body").click((event) => {
    if (!preventClosingModal(event.target) && $("body").hasClass("modalOpen")) {
      event.preventDefault();
      $('body').removeClass("modalOpen");
      $('#hideContent').slideToggle(100);
    }
  });
});
